import React, { useEffect, useRef, useState } from 'react';
import TakeLookTopSection from '../../../components/TakeALook/TakeLookTopSection';
import TakeLookSubHeading from '../../../components/TakeALook/TakeLookSubHeading';

import InstagramLogo from '../../../assets/img/customer-service-center/Instagram.png';
import FacebookLogo from '../../../assets/img/customer-service-center/Facebook.png';
import KakaoLogo from '../../../assets/img/customer-service-center/Kakao.png';

// Kakao JS Key here
// const KAKAO_KEY = process.env.REACT_APP_KAKAO_KEY || 'YOUR_KAKAO_JAVASCRIPT_KEY';
// const KAKAO_KEY = '14be42c9a3c3c7f2f24153d25810ba11';
const KAKAO_KEY = 'a13a559fb1f5b864d81b8a4a48c07c0c';

const TakeLookPCFullView = () => {
  const externalLink = 'https://prds.gigachances.com/index_a.html';
  const [isShareOpen, setIsShareOpen] = useState(false);
  const shareRef = useRef(null);


  useEffect(() => {

    if (typeof window !== 'undefined' && window.Kakao) {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(KAKAO_KEY);
        console.log('Kakao initialized:', window.Kakao.isInitialized());
      }
      return;
    }


    if (!document.getElementById('kakao-sdk')) {
      const script = document.createElement('script');
      script.id = 'kakao-sdk';
      script.src = 'https://developers.kakao.com/sdk/js/kakao.js';
      script.async = true;
      script.onload = () => {
        if (window.Kakao && !window.Kakao.isInitialized()) {
          window.Kakao.init(KAKAO_KEY);
          console.log('Kakao SDK loaded and initialized');
        }
      };
      document.body.appendChild(script);
    }
  }, []);


  useEffect(() => {
    const onClickOutside = (e) => {
      if (shareRef.current && !shareRef.current.contains(e.target)) {
        setIsShareOpen(false);
      }
    };
    const onEsc = (e) => {
      if (e.key === 'Escape') setIsShareOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
      document.removeEventListener('keydown', onEsc);
    };
  }, []);

  const toggleShare = () => setIsShareOpen((v) => !v);


  const handleShareClick = (platform) => {
    const currentUrl = window.location.href;

    if (platform === 'facebook') {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
        '_blank',
        'width=600,height=500'
      );
    }

    if (platform === 'instagram') {
      window.open('https://www.instagram.com/', '_blank', 'width=1200,height=800');
    }

    if (platform === 'kakao') {
      if (window.Kakao && window.Kakao.isInitialized()) {
        try {
          window.Kakao.Link.sendDefault({
            objectType: 'feed',
            content: {
              title: document.title || 'Take a Look',
              description: 'Take a Look 공유하기',
              imageUrl: 'https://your-public-image-url.com/share.png',
              link: {
                mobileWebUrl: currentUrl,
                webUrl: currentUrl,
              },
            },
            buttons: [
              {
                title: '웹에서 보기',
                link: {
                  mobileWebUrl: currentUrl,
                  webUrl: currentUrl,
                },
              },
            ],
          });
        } catch (e) {
        
          window.open(
            'https://developers.kakao.com/tool/demo/message/kakaolink',
            '_blank',
            'width=720,height=800'
          );
        }
      } else {
       
        window.open(
          'https://developers.kakao.com/tool/demo/message/kakaolink',
          '_blank',
          'width=720,height=800'
        );
      }
    }

    setIsShareOpen(false);
  };

  return (
    <div className="announcement-list-page take-look-info-page">
      <TakeLookTopSection />

      <main className="main-content">
        <TakeLookSubHeading heading="A관" />

        <div className="take-look-page-content">
          <div className="full-view-content">

            {/* Iframe */}
            <div className="full-view-iframe-container" style={{ width: '100%', height: '600px' }}>
              <iframe
                src={externalLink}
                title="PC Take a Look Full View"
                style={{ width: '100%', height: '100%', border: 'none', overflow: 'hidden' }}
                allowFullScreen
              />
            </div>

            {/* Share Section */}
            <div className="full-view-share-section">
              <div ref={shareRef} className="share-container">
                <button
                  type="button"
                  className="full-view-share-button"
                  aria-haspopup="true"
                  aria-expanded={isShareOpen}
                  aria-controls="share-popup"
                  onClick={toggleShare}
                >
                   <span className="share-text">SNS 공유</span>
                  <img src="/images/TakeLook/share.png" alt="공유하기" className="logo" />
                </button>

                {isShareOpen && (
                  <div
                    id="share-popup"
                    role="dialog"
                    aria-label="공유하기"
                    className="share-popup"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="popup-title">공유하기</div>

                    <div className="popup-buttons">
                      <button
                        type="button"
                        className="social-btn"
                        onClick={() => handleShareClick('instagram')}
                        aria-label="Instagram으로 공유하기"
                        title="Instagram으로 공유하기"
                      >
                        <img src={InstagramLogo} alt="Instagram" className="logo" />
                      </button>

                      <button
                        type="button"
                        className="social-btn"
                        onClick={() => handleShareClick('facebook')}
                        aria-label="Facebook으로 공유하기"
                        title="Facebook으로 공유하기"
                      >
                        <img src={FacebookLogo} alt="Facebook" className="logo" />
                      </button>

                      <button
                        type="button"
                        className="social-btn"
                        onClick={() => handleShareClick('kakao')}
                        aria-label="KakaoTalk으로 공유하기"
                        title="KakaoTalk으로 공유하기"
                      >
                        <img src={KakaoLogo} alt="KakaoTalk" className="logo" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
};

export default TakeLookPCFullView;


